import { Serializable } from '@/models/core/serializable';
import { GEnum } from '@/constants/enum.defination';

export class Big5 implements Serializable<Big5> {
  Big5ID: number;
  Title: string;
  HighScoreTitle: string;
  LowScoreTitle: string;

  deserialize(input: any) {
    this.Big5ID = input.big5ID;
    this.Title = input.Title;
    this.HighScoreTitle = input.highScoreTitle;
    this.LowScoreTitle = input.lowScoreTitle;
    return this;
  }

  get id(): number {
    return this.Big5ID;
  }

  get color(): string {
    switch (this.Big5ID) {
      case GEnum.Big5.ID1:
        return '#0050b3';
      case GEnum.Big5.ID2:
        return '#237804';
      case GEnum.Big5.ID3:
        return '#ad8b00';
      case GEnum.Big5.ID4:
        return '#391085';
      case GEnum.Big5.ID5:
        return '#a8071a';
    }
  }
}
